const BugReporterIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 100 100"
    >
      <ellipse
        cx="50"
        cy="50"
        rx="12"
        ry="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="4"
      />

      <ellipse
        cx="50"
        cy="32"
        rx="8"
        ry="6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />

      <line
        x1="40"
        y1="40"
        x2="30"
        y2="30"
        stroke="currentColor"
        strokeWidth="4"
      />
      <line
        x1="60"
        y1="40"
        x2="70"
        y2="30"
        stroke="currentColor"
        strokeWidth="4"
      />
      <line
        x1="40"
        y1="60"
        x2="30"
        y2="70"
        stroke="currentColor"
        strokeWidth="4"
      />
      <line
        x1="60"
        y1="60"
        x2="70"
        y2="70"
        stroke="currentColor"
        strokeWidth="4"
      />

      <line
        x1="46"
        y1="27"
        x2="43"
        y2="20"
        stroke="currentColor"
        strokeWidth="4"
      />
      <line
        x1="54"
        y1="27"
        x2="57"
        y2="20"
        stroke="currentColor"
        strokeWidth="4"
      />
    </svg>
  );
};

export default BugReporterIcon;
